import {Repository, createRepository} from '@/repositories/Base/Repository'

class PerformanceRepository extends Repository {
    endpoint = 'vam/performance'

}

export default new PerformanceRepository()

export const create = createRepository(PerformanceRepository)
